module.exports = __webpack_public_path__ + "img/logo.c5df714f.svg";